
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/billing/profiles",
      function () {
        return require("private-next-pages/billing/profiles.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/billing/profiles"])
      });
    }
  